import { render, staticRenderFns } from "./AddNewComponent.vue?vue&type=template&id=4535b20b&scoped=true"
import script from "./AddNewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddNewComponent.vue?vue&type=style&index=0&id=4535b20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535b20b",
  null
  
)

export default component.exports